module.exports = __webpack_public_path__ + "static/media/Ex3-S2-AV-2.a4bf8e9f.PNG";